/**
 * DOM-based Routing
 *
 * Based on:
 *  @link https://www.paulirish.com/2009/markup-based-unobtrusive-comprehensive-dom-ready-execution/
 *   - Markup-based Unobtrusive Comprehensive DOM-ready Execution by Paul Irish
 *  @link https://www.viget.com/articles/extending-paul-irishs-comprehensive-dom-ready-execution/
 *   - Extending Paul Irish’s comprehensive DOM-ready execution by Jason Garber
 *
 * The routing fires all common scripts, followed by the controller and action scripts.
 */
class Router {

    /**
     * Create a new Router
     * @param {Object} routes
     */
    constructor(routes) {
        this.routes = routes;
    }

    /**
     * Fire Router events
     * @param {string} route DOM-based route derived from data-* attributes on the body element (`<body data-controller="..." data-action="...">`)
     * @param {string} [event] Events on the route. By default, an `init` event is called.
     * @param {string} [arg] Any custom argument to be passed to the event.
     */
    fire(route, event = 'init', arg) {
        const fire = route !== '' && this.routes[route] && typeof this.routes[route][event] === 'function';
        if (fire) {
            this.routes[route][event](arg);
        }
    }

    /**
     * Automatically load and fire Router events
     *
     * Events are fired in the following order:
     *  * common init
     *  * controller init
     *  * controller action
     *  * common finalize
     */
    loadEvents() {
        // Fire common init JS
        this.fire('common');

        // Fire controller init JS, and then finalize JS
        let body = document.body,
            controller = body.getAttribute('data-controller'),
            action = body.getAttribute('data-action');

        // Fire controller JS, and then action JS
        this.fire(controller);
        this.fire(controller, action);

        // Fire common finalize JS
        this.fire('common', 'finalize');
    }
}

export default Router;
